import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../../config";
import axiosClient from "../../../common/api/request";

// A 500 or a body that is not an object reads as the request's own message,
// the same rule the report downloads use for their error toasts.
const toRejectValue = (error) =>
  error?.response?.data &&
  typeof error.response.data === "object" &&
  error?.response?.status !== 500
    ? error.response.data
    : { Error: error?.message };

const createTopRegionsThunk = (endpoint) =>
  createAsyncThunk(
    `topRegionsV3/${endpoint}`,
    async (params, { rejectWithValue }) => {
      try {
        return await axiosClient.get(
          `${config.API_URL_V3}/top_regions/${endpoint}/`,
          { params }
        );
      } catch (error) {
        return rejectWithValue(toRejectValue(error));
      }
    }
  );

export const getTopRegionsRanking = createTopRegionsThunk("ranking");
export const getTopRegionsShare = createTopRegionsThunk("share");
export const getTopRegionsDaily = createTopRegionsThunk("daily");
export const getTopRegionsDetails = createTopRegionsThunk("details");
export const downloadTopRegions = createTopRegionsThunk("download");
export const getTopRegionsInsights = createTopRegionsThunk("insights");
export const getTopRegionsInsightsCustomers =
  createTopRegionsThunk("insights/customers");
